export default __webpack_public_path__ + "static/Beer_Barrel-58e5ecfc7b7e1bb07d40147a2ab193c6.png";